export const SUPERBUILDER_SELECT = 'SUPERBUILDER_SELECT';
export const SUPERBUILDER_MANDATORY_STATUS = 'SUPERBUILDER_MANDATORY_STATUS';

export const selectSuperBuilderVariant = (selectedCombinedSuperBuilderKeys) => ({
    type: SUPERBUILDER_SELECT,
    payload: selectedCombinedSuperBuilderKeys   
})

export const setSectionsSelected = (value) => ({
    type: SUPERBUILDER_MANDATORY_STATUS,
    payload: value   
})